export default{
    msg:'',
    editar:{},
    lista:'',
    pesquisa:'',
    trabalhador:'',
}